import React from 'react';
import PropTypes from 'prop-types';

import { fullName } from '../../../../common/helpers/users';

const renderOption = barber => (
  <option key={barber.id} value={barber.id} data-automation-id={`option:barbers:${barber.id}`}>
    {fullName(barber)}
  </option>
);

const BarberSelect = props => (
  <div className="u-mb u-1/1-medium-and-down">
    <label htmlFor="barber-select" className="c-label-new u-block">Barber</label>
    <select
      id="barber-select"
      disabled={props.isFetching}
      className="c-select u-width-100 u-max-width-100"
      data-automation-id="filter:barbers"
      onChange={props.onChange}
    >
      <option value="" data-automation-id="option:barbers:all">All</option>
      {
        props.barbers.map(renderOption)
      }
    </select>
  </div>
);

BarberSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  barbers: PropTypes.array,
};

export default BarberSelect;
